import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { TPopoverIds } from "../../../../../../app/state/popoverSlice/types";
import { AppPopover } from "../../../../../../common/AppPopover";
import { useAppSelector } from "../../../../../../services/redux/hooks/use-selector";
import { AppCheckbox } from "../../../../../../shared/components/AppCheckbox";
import { PasswordInput } from "../../../../../Auth/AuthForm/Components/PasswordInput";
import { selectSpaUriObject } from "../../../../redux/selectors";
import { useStorageSelectors } from "../../../../../../app/state/storageObjectSlice/hook/use-storage-selectors";
import { usePopoverSelectors } from "../../../../../../app/state/popoverSlice/hook/use-popover-selectors";
import styles from "./styles.module.css";

interface Props {
  closePopover: (id: TPopoverIds) => void;
  handleChangePublish: (password: string, checked: boolean) => void;
}

export const PublishLinkPopover = ({
  closePopover,
  handleChangePublish,
}: Props) => {
  const publishLinkPopover = usePopoverSelectors("publish_link_popover");
  const spaUriObject = useAppSelector(selectSpaUriObject);
  const { selectedId } = useStorageSelectors("ai_agents_spa");
  const [pass, setPass] = useState<string>("");
  const [checkedUser, setCheckedUser] = useState<boolean>(false);
  const [visiblePass, setVisiblePass] = useState<boolean>(false);
  const { t } = useTranslation();

  useEffect(() => {
    setPass(spaUriObject?.publish?.password ?? "");
    setCheckedUser(spaUriObject?.publish?.only_for_platform_user ?? false);
  }, [spaUriObject?.publish, selectedId]);

  const handleChangePass = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPass(event.target.value);
  };

  const handleChangeUserChecked = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setCheckedUser(event.target.checked);
  };

  return (
    <AppPopover
      open={publishLinkPopover.isOpen}
      onClose={() => closePopover("publish_link_popover")}
      onOk={() => {
        handleChangePublish(pass, checkedUser);
        closePopover("publish_link_popover");
      }}
      handleClose={() => closePopover("publish_link_popover")}
      anchorReference={"anchorPosition"}
      anchorPosition={{
        left: (publishLinkPopover.position?.x ?? 0) + 35,
        top: (publishLinkPopover.position?.y ?? 0) + 35,
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
    >
      <PasswordInput
        password={pass}
        onChange={handleChangePass}
        isPasswordVisible={visiblePass}
        onClick={() => setVisiblePass(!visiblePass)}
        className={styles["spa-password"]}
      />
      <AppCheckbox
        checked={checkedUser}
        onChange={handleChangeUserChecked}
        containerClassName={styles.checkbox}
      >
        {t("editor.security_checked")}
      </AppCheckbox>
    </AppPopover>
  );
};
